import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _class, _temp;

import React, { Component } from 'react';
import { ThemeProvider } from 'styled-components';
import createCard from '../../createCard';
import propTypes from './propTypes';
import BlockquoteView from './BlockquoteView';
import PullquoteView from './PullquoteView';
import { TYPE, FLOAT } from './enums';

var QuoteCardView = (_temp = _class = function (_Component) {
  _inherits(QuoteCardView, _Component);

  function QuoteCardView() {
    _classCallCheck(this, QuoteCardView);

    return _possibleConstructorReturn(this, (QuoteCardView.__proto__ || _Object$getPrototypeOf(QuoteCardView)).apply(this, arguments));
  }

  _createClass(QuoteCardView, [{
    key: 'getComponent',
    value: function getComponent() {
      switch (this.props.type) {
        case TYPE.PULLQUOTE:
          return PullquoteView;
        default:
          return BlockquoteView;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var Comp = this.getComponent();
      return React.createElement(
        ThemeProvider,
        { theme: {} },
        React.createElement(Comp, this.props)
      );
    }
  }]);

  return QuoteCardView;
}(Component), _class.TYPE = TYPE, _class.FLOAT = FLOAT, _class.propTypes = propTypes, _temp);


export default createCard({
  name: 'QuoteCard',
  renderWith: QuoteCardView
});